import React, { useEffect, useState } from 'react'
import NavbarContainer from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import ProductsGallery from '../components/ProductsGallery/ProductsGallery'
import RelatedProdtcts from '../components/RelatedProdtcts/RelatedProdtcts'
import ProductInfo from '../components/ProductInfo/ProductInfo'
import { Col, Container, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import ReviewProdtcts from '../components/ReviewProdtcts/ReviewProdtcts'

function ProductDetails() {
  const { id } = useParams(); // Extracts the "id" from the URL
  const [product, setProduct] = useState([])
  useEffect(() => {
    const getAllApis = async () => {

      await axios
        .get(`https://nanosoft.technology/smile/api/products`)
        .then(async (res) => {
                    const product=res.data.data.filter(item=>item?.id==id)
          console.log(product);
          
          setProduct(product);

          console.log('res.data',res.data);
          

        })
        .catch((error) => {

          console.log(error);


        });
    }
    getAllApis()
  }, [])

  return (
    <div>
      <NavbarContainer />
      <Container>
        <Row>
          <Col md={6}>
            <ProductsGallery
              images={product && product?.[0]?.images}
            />
          </Col>
          <Col md={6}>
            <ProductInfo
              info={product && product?.[0]}
            />
          </Col>
        </Row>
        <Row>
          {/* <ReviewProdtcts
            products={product && product.relatedProducts}
          /> */}
        </Row>
        <Row>
          {/* <RelatedProdtcts
            products={product && product.relatedProducts}
          /> */}
        </Row>
      </Container>
      <Footer />
    </div>
  )
}

export default ProductDetails